<template>
  <router-view />
  <Toast position="bottom-right" />
  <ConfirmDialog />
</template>

<script setup lang="ts">
// Global overlays (toast + confirm) live here so every view can use
// useToast()/useConfirm(). Layout lives in components/AppShell.vue.
import { onMounted } from "vue";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
import { useAuthStore } from "./stores/auth";

/*
 * Re-read the profile once on boot (O3).
 *
 * The header's org context and switcher render off the cached user in
 * localStorage, but ``organizations`` only ever arrives on an AUTH
 * response — so an administrator adding you to a second organization
 * would otherwise not show up until your access token happened to
 * rotate. One /auth/me per app load keeps the tenant you are acting as,
 * and the list you may switch to, honest. Failures are swallowed by the
 * store (the client's own 401 flow handles a dead session).
 */
const auth = useAuthStore();
onMounted(() => {
  if (auth.isLoggedIn) void auth.refreshMe();
});
</script>
